module.exports = __webpack_public_path__ + "674bb01975e7556439d75c6f31394dca.svg";